import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User submitted a collection form',
  name: 'Submitted collection form',
  params: [
    {
      description: 'If true, this is an auto-submitted form session asset batch',
      name: 'auto_submit',
      required: true,
      type: 'boolean',
    },
  ],
};

export default META;
